import React, { useState } from "react"
import axios from "axios"
import { ArrowRight, Mail } from "react-feather"
import { Heading } from "@bancacfplus/Heading"
import { InfoBox } from "@bancacfplus/InfoBox"
import { MenuLogo, MenuWrapper } from "../../components/Menu/Menu"
import { loadEnvVars } from "../../utils/loadEnvVars"
import * as style from "./signup-success.module.scss"
import { Loader } from "../../components/Loader"

export const SignUpSuccess = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const { expressApiGateway } = loadEnvVars()

  const search = location?.search ?? ""
  const urlSearchParams = new URLSearchParams(search)
  const queryParameters = Object.fromEntries(urlSearchParams.entries())
  const email = queryParameters.email

  const handleResend = async () => {
    try {
      setIsLoading(true)
      setIsError(false)

      await axios.post(`${expressApiGateway}/resendUserEmail`, { email })
    } catch (error) {
      setIsError(true)

      console.error("Error while resending email to user", error)
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return <Loader fullPage />
  }

  return (
    <div>
      <MenuWrapper>
        <MenuLogo />
      </MenuWrapper>
      <main className={style.content}>
        <div className={style.card}>
          <Mail size={20} aria-hidden="true" />
          <Heading as="h1" className={style.title}>
            Controlla la tua email
          </Heading>
          <p>
            Clicca sul link presente nell&apos;email che hai ricevuto per completare la registrazione e accedere alla
            tua area riservata.
          </p>
          <div className={style.note}>
            <p className={style.text}>Non hai ricevuto l&apos;email?</p>
            <p className={style.text}>
              Controlla nella cartella Spam oppure{" "}
              <span className={style.linkContainer}>
                <button
                  onClick={handleResend}
                  className={`${isLoading ? style.linkLoading : style.link}`}
                  disabled={isLoading}
                >
                  Invia di nuovo
                  <ArrowRight className={style.arrow} size={22} aria-hidden="true" />
                </button>
              </span>
            </p>
          </div>
          {isError && (
            <InfoBox type="error" className={style.errorBox}>
              Qualcosa è andato storto nell&apos;invio. Riprova.
            </InfoBox>
          )}
        </div>
      </main>
    </div>
  )
}
